//boards
export const SET_ALL_BOARDS = "SET_ALL_BOARDS";
export const DELETE_BOARD = "DELETE_BOARD";
export const ADD_NEW_BOARD = "ADD_NEW_BOARD";
export const UPDATE_BOARD = "UPDATE_BOARD";
export const SET_SINGLE_BOARD = "SET_SINGLE_BOARD";
export const SET_SINGLE_BOARD_FROM_STORE = "SET_SINGLE_BOARD_FROM_STORE";
export const UPDATE_PURPOSE = "UPDATE_PURPOSE";
//tasks
export const DELETE_TASK = "DELETE_TASK";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const UNARCHIVE_TASK = "UNARCHIVE_TASK";
export const ARCHIVE_TASK = "ARCHIVE_TASK";
export const SET_TASK_SORTING = "SET_TASK_SORTING";
//mytasks
export const ADD_MY_TASK = "ADD_MY_TASK";
export const SET_ALL_MY_TASKS = "SET_ALL_MY_TASKS";
export const UPDATE_MY_TASK = "UPDATE_MY_TASK";
export const DELETE_MY_TASK = "DELETE_MY_TASK";
export const ADD_COMMENT_TO_MY_TASK = "ADD_COMMENT_TO_MY_TASK";
export const UPDATE_COMMENT_TO_MY_TASK = "UPDATE_COMMENT_TO_MY_TASK";
export const DELETE_COMMENT_FROM_MY_TASK = "DELETE_COMMENT_FROM_MY_TASK";
export const ADD_COMMENT_REPLY_TO_MY_TASK = "ADD_COMMENT_REPLY_TO_MY_TASK";
//comments
export const SET_ALL_COMMENTS = "SET_ALL_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const ADD_REPLY = "ADD_REPLY";
export const UPDATE_REPLY = "UPDATE_REPLY";
export const DELETE_REPLY = "DELETE_REPLY";
//User Data
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_HVI_DATA = "SET_HVI_DATA";

// Board Notes
export const SET_ALL_BOARDS_NOTES = "SET_ALL_BOARDS_NOTES";
export const ADD_BOARD_NOTE = "ADD_BOARD_NOTE";
export const UPDATE_BOARD_NOTE = "UPDATE_BOARD_NOTE";
export const DELETE_BOARD_NOTE = "DELETE_BOARD_NOTE";

// Battery Level.
export const SET_BATTERY_LEVEL = "SET_BATTERY_LEVEL";
export const ADD_BATTERY_LEVEL = "ADD_BATTERY_LEVEL";
export const UPDATE_BATTERY_LEVEL = "UPDATE_BATTERY_LEVEL";
export const DELETE_BATTERY_LEVEL = "DELETE_BATTERY_LEVEL";
